import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel" className="pt-40 md:pt-52 pb-32 mx-auto max-w-[900px] px-5 md:px-10 min-h-[60vh]">
      <div className="font-label text-xs" style={{ color: "var(--ss-rust)" }}>Payment Cancelled</div>
      <h1 className="mt-4 font-display font-light tracking-tighter text-5xl md:text-7xl">No worries.</h1>
      <p className="mt-6 font-body text-lg md:text-xl max-w-2xl" style={{ color: "var(--ss-cream-dim)" }}>
        Your payment was cancelled. No charge was made. When you're ready, head back to Events.
      </p>
      <Link to="/events" data-testid="cancel-events-btn" className="btn-primary mt-8 inline-flex">Back to Events <ArrowUpRight className="arrow" size={14} /></Link>
    </div>
  );
}
